import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {AlertController, ModalController} from '@ionic/angular';
import {ValidateDocumentService} from '../../services/validate-document.service';
import {GeneralSaveDocumentService} from '../../services/general-save-document.service';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import {BarcodeOptions} from '../../definitions/barcode-options';
import {ScanBarcodeService} from '../../services/scan-barcode.service';
import {GeneralService} from '../../services/general.service';
import {StockTakeHelperService} from '../../services/stock-take-helper.service';
import {ProductMultiSelectComponent} from '../product-multi-select/product-multi-select.component';
import {PersistDocumentService} from '../../services/persist-document.service';

@Component({
    selector: 'app-purchase-order',
    templateUrl: './purchase-order.component.html',
    styleUrls: ['./purchase-order.component.scss'],
})
export class PurchaseOrderComponent implements OnInit {
    @Input() document: DocumentModel;
    documentTemp: DocumentModel;
    queryText: string;

    constructor(private modalController: ModalController,
                private validateDoc: ValidateDocumentService,
                private persistDocumentService: PersistDocumentService,
                private alertController: AlertController,
                private barcodeScanner: BarcodeScanner,
                private barcodeOptions: BarcodeOptions,
                private scanBarcodeService: ScanBarcodeService,
                private generalService: GeneralService,
                private stockTakeHelper: StockTakeHelperService) {
    }

    ngOnInit() {
        this.documentTemp = JSON.parse(JSON.stringify(this.document));
    }

    async editQty(line: DetaillineDTOModel) {
        const alert = await this.alertController.create({
            header: 'Edit Quantity',
            message: 'Please inform new quantity.',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'qty',
                    type: 'number',
                    placeholder: 'Quantity'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }, {
                    text: 'Ok',
                    handler: data => {
                        line.qty = data.qty;
                    }
                }
            ]
        });
        await alert.present();
    }

    async scanItem() {
        this.barcodeScanner.scan(this.barcodeOptions.options).then(barcode => {
            console.log(barcode.text);
            this.handleScanResult(barcode.text);
        }).catch(err => {
            console.log(err);
        });
        // TODO: Add PWA back
        // const modal = await this.modalController.create({
        //     component: null,
        //     backdropDismiss: false,
        //     cssClass: 'modal-fullscreen',
        //     componentProps: {
        //         document: this.documentTemp,
        //         reconciliation: true
        //     }
        // });
        // modal.onDidDismiss().then(() => {
        // });
        // return await modal.present();
    }

    async handleScanResult(barcode) {
        console.log('Scan Result');
        console.log(barcode);
        const stockLine = this.scanBarcodeService.findProductWithBarcode(barcode) as DetaillineDTOModel;
        if (stockLine) {
            this.confirmEquipment(JSON.parse(JSON.stringify(stockLine)));
        } else {
            await this.generalService.createToast('No match with barcode: ' + barcode);
            if (barcode) {
                this.scanItem();
            }
        }
    }

    async confirmEquipment(product) {
        const alert = await this.alertController.create({
            header: 'Equipment found: ' + product.description,
            message: 'Please inform quantity.',
            backdropDismiss: false,
            inputs: [
                {
                    name: 'qty',
                    type: 'number',
                    placeholder: 'Quantity'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                        this.scanItem();
                    }
                }, {
                    text: 'Yes',
                    handler: data => {
                        console.log(data.qty);
                        this.stockTakeHelper.addItemToStockCount(this.documentTemp, product, data.qty);
                        this.scanItem();
                    }
                }
            ]
        });
        await alert.present();
    }

    async addItem() {
        const modal = await this.modalController.create({
            component: ProductMultiSelectComponent,
            backdropDismiss: false,
            cssClass: 'modal-fullscreen',
            componentProps: {
                document: this.documentTemp
            }
        });
        modal.onDidDismiss().then(() => {
        });
        return await modal.present();
    }

    savePurchaseOrder() {
        if (!this.validateDoc.isValid(this.documentTemp)) {
            return;
        } else {
            this.document = JSON.parse(JSON.stringify(this.documentTemp));
            this.persistDocumentService.persistDocument(this.document);
            this.generalService.createToast('Purchase Order Saved!');
            this.modalController.dismiss();
        }
    }

    async cancelPurchaseOrder() {

        const alert = await this.alertController.create({
            message: 'Do you want to cancel the Purchase Order?',
            backdropDismiss: false,
            buttons: [
                {
                    text: 'No',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () => {
                    }
                }, {
                    text: 'Yes',
                    handler: () => {
                        this.modalController.dismiss();
                    }
                }
            ]
        });
        await alert.present();
    }
}
